import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

import { constantes } from '../../../core/data/Constantes';
import { GenericDto } from '../../../core/data/GenericDto';
import { InformacionFiltroDetalleSucursalesDto } from '../data/InformacionFiltroDetalleSucursalesDto';
import { InformacionCambiarEstadoVentaDto } from '../data/InformacionCambiarEstadoVentaDto';
import { ConsultarMensajeDto } from '../data/ConsultarMensajeDto';
import { EnviarMensajeRemitenteDto } from '../data/EnviarMensajeRemitenteDto';
import { ConsultarMensajeLeidoDto } from '../data/ConsultarMensajeLeidoDto';
import { InformacionFiltroMensajeriaDto } from '../data/InformacionFiltroMensajeriaDto';

@Injectable({
  providedIn: 'root'
})
export class DetalleSucursalesService {

  respuesta = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8' }),
  };

  constructor(private http: HttpClient) { }


  public consultarInformacionTablaDetalleSucursales(dataFiltros: InformacionFiltroDetalleSucursalesDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CONSULTAR_TABLA_DETALLE_SUCURSALES, dataFiltros, this.respuesta);
  }

  public consultarTotalesCardDetalleSucursales(dataFiltros: InformacionFiltroDetalleSucursalesDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CONSULTAR_TOTALES_CARD_DETALLE_SUCURSALES, dataFiltros, this.respuesta);
  }

  public consultarInformacionModalBalanceOtrosProductos(dataFiltros: InformacionFiltroDetalleSucursalesDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.MODAL_BALANCE_OTROS_PRODUCTOS, dataFiltros, this.respuesta);
  }

  public consultarInformacionModalOtrosProductos(dataFiltros: InformacionFiltroDetalleSucursalesDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.MODAL_OTROS_PRODUCTOS, dataFiltros, this.respuesta);
  }

  public cambiarEstadoVenta(data: InformacionCambiarEstadoVentaDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CAMBIAR_ESTADO_DE_VENTA, data, this.respuesta);
  }

  public consultarMensajes(dataFiltros: ConsultarMensajeDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CONSULTAR_MENSAJERIA, dataFiltros, this.respuesta);
  }

  public consultarCantidadMensajesSinLeer(data: ConsultarMensajeDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.CONSULTAR_CANTIDAD_MENSAJES_SIN_LEER, data, this.respuesta);
  }

  public enviarMensajeRemitente(data: EnviarMensajeRemitenteDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.REGISTRAR_RESPUESTA_REMITENTE, data, this.respuesta);
  }

  public mensajeLeido(data: ConsultarMensajeLeidoDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.ESTADO_MENSAJE_A_LEIDO, data, this.respuesta);
  }

  public marcarMensajesComoLeidos(data: ConsultarMensajeLeidoDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.MARCAR_MENSAJES_COMO_LEIDOS, data, this.respuesta);
  }

  public registroMensaje(data: InformacionFiltroMensajeriaDto): Observable<GenericDto> {
    return this.http.post<GenericDto>(environment.api + constantes.ENVIO_MENSAJERIA, data, this.respuesta);
  }

  public consultarUltimaHoraActualizacionDash(): Observable<GenericDto> {
    return this.http.get<GenericDto>(environment.api + constantes.CONSULTAR_HORA_ULTIMA_ACTUALIZACION);
  }
}
